import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import classes from './FamilyEnrollmentsPage.module.scss'
import FilterButton from './components/FilterButton'
// import LoadingSpinner from '../common/loader/legacy-loaders/LoadingSpinner'
import MembersEnrollmentsTable from './components/MembersEnrollmentsTable'
import { useOutletContext } from 'react-router-dom'
import Loader from '../common/loader/Loader'
import TablePlaceholder from './components/TablePlaceholder'

const FILTER_OPTIONS = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
}

const FamilyEnrollmentsPage = () => {
  const { t } = useTranslation()
  const { family } = useOutletContext()
  const [enrollments, setEnrollments] = useState(null)
  const [filterOption, setFilterOption] = useState(FILTER_OPTIONS.ALL)

  const handleFilter = (option) => {
    setFilterOption(option)

    if (option !== FILTER_OPTIONS.ALL) {
      setEnrollments(family.enrollments.filter(enrollment => enrollment.status.toLowerCase() === option.toLowerCase()))
    } else {
      setEnrollments(family.enrollments)
    }
  }

  useEffect(() => {
    setEnrollments(family.enrollments)
  }, [family])

  if (!enrollments) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>{t('members.loading.familyEnrollments')}</Loader>
      </div>
    )
  }

  return (
    <main className={classes.wrapper}>
      <header className='py-4 d-flex align-items-center'>
        <div className={classes.searchWrapper}>
          <h4 className={classNames('font-weight-bold mb-0', classes.title)}>
            {t('members.familyEnrollments.heading', { count: enrollments?.length || 0 })}
          </h4>
        </div>
        <div className={classes.filterOptions}>
          <FilterButton
            text={t('members.filters.all')}
            onClick={() => handleFilter(FILTER_OPTIONS.ALL)}
            isActive={filterOption === FILTER_OPTIONS.ALL}
          />
          <FilterButton
            text={t('members.filters.active')}
            onClick={() => handleFilter(FILTER_OPTIONS.ACTIVE)}
            isActive={filterOption === FILTER_OPTIONS.ACTIVE}
          />
          <FilterButton
            text={t('members.filters.completed')}
            onClick={() => handleFilter(FILTER_OPTIONS.COMPLETED)}
            isActive={filterOption === FILTER_OPTIONS.COMPLETED}
          />
        </div>
      </header>
      {enrollments?.length === 0 ? (
        <TablePlaceholder message={t('members.familyEnrollments.emptyState')} />
      ) : (
        <MembersEnrollmentsTable enrollments={enrollments} />
      )}
    </main>
  )
}

export default FamilyEnrollmentsPage
